import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { store } from './store'
import { AuthProvider } from './contexts/AuthContext'
import App from './App.jsx'
import './index.css'
import { initializeSentry } from './utils/sentry'

// Initialize Sentry (async, won't block rendering)
initializeSentry().catch(err => {
  console.warn('Failed to initialize Sentry:', err);
});

// Expose store to Cypress for testing
if (window.Cypress) {
  window.store = store;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </Provider>
)
